// extracted by mini-css-extract-plugin
export var footer = "_og-0";
export var inherit = "_og-1";
export var input = "_og-2";
export var modalContent = "_og-3";
export var quillEditor = "_og-4";
export var subtitle = "_og-5";